module.exports = __webpack_public_path__ + "static/img/myquiz.7148d90c.png";